const ENV_KDL_API_URL = process.env.REACT_APP_KDL_API_URL.concat('/').concat(process.env.REACT_APP_KDL_API_VERSION);
const ENV_KA_API_ROOT_URL = process.env.REACT_APP_KA_API_URL;
const ENV_KA_API_URL = ENV_KA_API_ROOT_URL.concat('/').concat(process.env.REACT_APP_KA_API_VERSION);

const KA_API_ROOT_URL = ENV_KA_API_ROOT_URL;
const KA_API_URL = ENV_KA_API_URL;
const KDL_API_URL = ENV_KDL_API_URL;

export { KA_API_ROOT_URL, KA_API_URL, KDL_API_URL };
